import React from 'react';
import { FadeIn } from './FadeIn';
export function Qualifier() {
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-surface border-y border-hyrox-muted" data-id="element-184">
      <div className="max-w-3xl mx-auto text-center" data-id="element-185">
        <FadeIn data-id="element-186">
          <h2 className="text-2xl sm:text-3xl font-display font-bold text-white mb-8" data-id="element-187">
            Pero antes de decirte el precio, necesito ser directo con vos.
          </h2>

          <div className="space-y-6 text-lg text-gray-300 leading-relaxed" data-id="element-188">
            <p data-id="element-189">
              Este pack <strong className="text-red-400" data-id="element-190">no es</strong> para el
              coach que quiere más PDFs para guardar en una carpeta que nunca va
              a abrir.
            </p>
            <p data-id="element-191">
              Es para el coach que está dispuesto a usarlo. Que va a abrir el
              Tomo 1 esta semana y va a repensar cómo entiende HYROX. Que va a
              implementar el sistema de evaluación con su próximo alumno. Que va
              a hacer la clase con estructura real en lugar de improvisar otra
              vez.
            </p>
            <p data-id="element-192">
              Es para el coach que entiende que HYROX no es "funcional con
              carrera" y que sus alumnos merecen un sistema que los lleve al
              resultado de verdad.
            </p>
            <p className="text-white font-bold text-xl mt-8" data-id="element-193">
              Si eso sos vos, este pack va a cambiar la forma en que trabajás.{' '}
              <br className="hidden sm:block" data-id="element-194" />
              <span className="text-hyrox-orange" data-id="element-195">
                No en tres meses. Desde la primera sesión.
              </span>
            </p>
            <p className="text-sm text-gray-500 mt-8 uppercase tracking-widest font-bold" data-id="element-196">
              Si no estás listo para implementarlo, no te lo vendas a vos mismo.
              No es para guardar. Es para usar.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}